export const LOAD_RETURN_POLICIES = 'load_return_policies';
export const RETURN_POLICIES_LOADED = 'return_policies_loaded';
export const LOAD_RETURN_POLICY = 'load_return_policy';
export const RETURN_POLICY_LOADED = 'return_policy_loaded';
export const RETURN_POLICY_DELETED = 'return_policy_return_policy_deleted';
export const RESET_RETURN_POLICIES = 'reset_return_policies';
export const RESET_RETURN_POLICY = 'reset_return_policy';
export const SYNC_FAILED = 'return_policy_sync_has_failed';
export const SAVE_RETURN_POLICY = 'save_return_policy';
export const RETURN_POLICIES_SAVED = 'return_policies_saved';
export const RETURN_POLICIES_POPUP = 'return_policies_popup';
export const SYNCING = 'syncing';
export const RESET_ERROR = 'reset_error';
